export default __webpack_public_path__ + "static/media/(3).bbe87327.jpg";